import { MarkdownParagraph } from './paragraph';

export class MarkdownHeader extends MarkdownParagraph {
  constructor(protected text: string, private prefix = '#') {
    super(text);
  }

  toString() {
    return `${this.prefix} ${this.text}`;
  }
}
